import { Component, ElementRef, Input } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { AnalyticsService } from 'pg-lib/services/analytics.service';
import { ExternalLinksService } from 'pg-lib/pg-ui-elements/external-links.service';

@Component({
    selector: 'app-totem-widget-buttons',
    templateUrl: './totem-widget-buttons.component.html',
    styleUrls: ['./totem-widget-buttons.component.scss'],
    standalone: false
})
export class TotemWidgetButtonsComponent extends TotemWidget {
    size: 'md' = 'md';

    constructor(
        public elementRef: ElementRef,
        private analyticsService: AnalyticsService,
        private externalLinksService: ExternalLinksService
    ) {
        super(elementRef);
    }

    @Input() buttonList: Array<{ icon: string; text: string; link: string }>;

    onButtonClick(index: number) {
        const button = this.buttonList[index];
        if (!button?.link) return;

        this.analyticsService.sendEvent('widgetOpenLink', {
            widget: this.id,
            link: button.link
        });

        this.externalLinksService.openExternalLink(button.link);
    }
}
